import { ProductProfitStatistics } from "../../../models/Statistics";

export const REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT =
  "REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT";
export const REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT_DONE =
  "REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT_DONE";

export interface FetchStoreProfitByProductStatistics {
  type: typeof REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT;
  payload: ReadonlyArray<ProductProfitStatistics>;
}

export interface FetchStoreProfitByProductStatisticsDone {
  type: typeof REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT_DONE;
  payload: ReadonlyArray<ProductProfitStatistics>;
}

export interface ProductProfitStatisticsState {
  isLoading: boolean;
  productProfitStatistics: ReadonlyArray<ProductProfitStatistics>;
}

export type ProductProfitStatisticsActions =
  | FetchStoreProfitByProductStatistics
  | FetchStoreProfitByProductStatisticsDone;
